import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSave, FiTerminal, FiDatabase, FiShield } = FiIcons;

const Settings = () => {
  return (
    <div className="space-y-6 max-w-4xl mx-auto pb-10">
      <div>
        <h1 className="text-2xl font-bold text-gray-100 tracking-wider">SYSTEM CONFIG</h1>
        <p className="text-xs font-mono text-gray-500 uppercase mt-1">Global Parameters & Integration</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2 space-y-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="hud-panel p-6">
            <h3 className="text-sm font-mono text-[#00f0ff] uppercase tracking-widest mb-6 flex items-center gap-2 border-b border-[#1a1a2e] pb-3">
              <SafeIcon icon={FiTerminal} /> Telemetry Settings
            </h3>
            
            <div className="space-y-5">
              <div>
                <label className="block text-[10px] font-mono text-gray-400 uppercase tracking-widest mb-2">Polling Frequency (ms)</label>
                <input type="text" defaultValue="5000" className="w-full bg-[#11111a] border border-[#1a1a2e] focus:border-[#00f0ff]/50 rounded px-3 py-2 text-sm font-mono text-gray-200 outline-none transition-all" />
              </div>
              
              <div className="flex items-center justify-between p-3 bg-[#11111a] border border-[#1a1a2e] rounded">
                <div>
                  <div className="text-sm text-gray-200">Auto-Reroute Engine</div>
                  <div className="text-[10px] font-mono text-gray-500 mt-1 uppercase">AI suggestions based on traffic</div>
                </div>
                <div className="w-10 h-5 bg-[#00f0ff]/20 rounded-full relative cursor-pointer border border-[#00f0ff]/50">
                  <div className="absolute right-1 top-0.5 w-4 h-4 bg-[#00f0ff] rounded-full shadow-[0_0_5px_#00f0ff]"></div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="hud-panel p-6">
            <h3 className="text-sm font-mono text-[#ff5500] uppercase tracking-widest mb-6 flex items-center gap-2 border-b border-[#1a1a2e] pb-3">
              <SafeIcon icon={FiShield} /> Security Protocols
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-sm text-gray-300">
                <input type="checkbox" defaultChecked className="accent-[#ff5500] w-4 h-4" />
                Require 2FA for Dispatch Override
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-300">
                <input type="checkbox" defaultChecked className="accent-[#ff5500] w-4 h-4" />
                Encrypt Vehicle Location Data (AES-256)
              </div>
            </div>
          </motion.div>
        </div>

        <div className="space-y-6">
          <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 }} className="hud-panel p-6">
            <h3 className="text-sm font-mono text-gray-400 uppercase tracking-widest mb-6 flex items-center gap-2 border-b border-[#1a1a2e] pb-3">
              <SafeIcon icon={FiDatabase} /> Data Usage
            </h3>
            <div className="space-y-4">
              <div>
                <div className="flex justify-between text-[10px] font-mono text-gray-400 mb-1">
                  <span>Storage</span>
                  <span>74%</span>
                </div>
                <div className="h-1.5 w-full bg-[#1a1a2e] rounded-full overflow-hidden">
                  <div className="h-full bg-blue-500 w-[74%]" />
                </div>
              </div>
              <p className="text-[10px] font-mono text-gray-500 leading-relaxed uppercase">
                Log retention set to 90 days. Auto-purge enabled for non-critical telemetry.
              </p>
            </div>
          </motion.div>
          
          <button className="w-full bg-[#00f0ff]/10 hover:bg-[#00f0ff]/20 text-[#00f0ff] border border-[#00f0ff]/50 py-3 rounded text-xs font-mono uppercase tracking-widest transition-all shadow-[0_0_15px_rgba(0,240,255,0.1)] flex items-center justify-center gap-2">
            <SafeIcon icon={FiSave} /> Apply Configuration
          </button>
        </div>
      </div>

      <footer className="pt-12 text-center">
        <p className="text-[10px] font-mono text-gray-600 uppercase tracking-widest">
          Made by LingLink AI and DigLab AI
        </p>
      </footer>
    </div>
  );
};

export default Settings;